module.exports = __webpack_public_path__ + "static/media/ic_launcher.66ebbea0.png";